import { restService } from '@/helpers/services/restService';
import router from '@/router';
import { authHeader } from './authHeader';

const authenticationUrl: string = restService.buildURL(process.env.VUE_APP_API_ADMIN_IMPERSONATE_OWNER_URL);

/**
 * Login user in API and persist returned token in local storage
 *
 * @param companyId
 * @param username
 * @param password
 */
async function login(companyId: string, username: string, password: string) {
    const user = await restService.post(
        authenticationUrl,
        { companyId, adminUsername: username, adminPassword: password },
        authHeader(),
        null);

    if (!user || !user.token) {
        return false;
    }

    user.locale = "de";
    localStorage.setItem("user", JSON.stringify(user));

    router.push("/");
}

export const impersonateAuthService = {
    login
}